import { Link } from '@tanstack/react-router'
import { Compass } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="flex size-12 items-center justify-center rounded-2xl border bg-card text-primary shadow-sm">
        <Compass className="size-6" />
      </div>
      <div>
        <p className="text-sm font-semibold text-primary tabular">404</p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="mt-1 text-sm text-muted-foreground">The page you’re looking for doesn’t exist or you don’t have access to it.</p>
      </div>
      <Button asChild>
        <Link to="/">Go to dashboard</Link>
      </Button>
    </div>
  )
}

export function RouteErrorPage({ error, reset }: { error: unknown; reset?: () => void }) {
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-4 px-6 text-center" role="alert">
      <h1 className="text-xl font-semibold">Something went wrong</h1>
      <p className="max-w-md text-sm text-muted-foreground">{error instanceof Error ? error.message : 'An unexpected error occurred.'}</p>
      <div className="flex gap-2">
        {reset && (
          <Button variant="outline" onClick={reset}>
            Try again
          </Button>
        )}
        <Button asChild>
          <Link to="/">Go to dashboard</Link>
        </Button>
      </div>
    </div>
  )
}
